import Select from "react-select";
import Styles from "./index.module.scss";
import clsx from "clsx";
import { useAdminRateLimit } from "../../../Hooks/useAdminRateLimit";
import PaginationComponent from "../../../Share/Component/Pagination";
import { RATE_LIMIT_FUNCTIONS } from "../../../Constants/rateLimit";
import { AdminTable } from "../../../Components/Atoms/AdminTable";

function AdminRateLimit() {
  const {
    rateLimits,
    paging,
    search,
    setSearch,
    getRateLimits,
    type,
    handleSelectType,
    rateLimitColumns,
  } = useAdminRateLimit();

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.search)}
              />
              <span
                onClick={() => getRateLimits(0)}
                className={clsx(Styles.btnSearch)}
              >
                Search
              </span>
            </div>
            <div className={clsx(Styles.filterBody)}>
              <div className={clsx(Styles.typeWrap)}>
                <Select
                  value={type}
                  onChange={handleSelectType}
                  options={RATE_LIMIT_FUNCTIONS}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <AdminTable columns={rateLimitColumns} data={rateLimits} />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent page={paging} handleCallApi={getRateLimits} />
          </div>
        </div>
      </div>
    </div>
  );
}
export default AdminRateLimit;
